module.exports = __webpack_public_path__ + "img/hexagon_shape.3b9ec4d8.svg";